export default {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 8,
  xl: 8,
  xxl: 6,
}
